import GQlogo from "./logos/GQ.png";
import ATZlogo from "./logos/ATZ.png";
import FNClogo from "./logos/FNC.png";
import LOUDlogo from "./logos/LOUD.png";
import SCNlogo from "./logos/SCN.png";
import TMNTlogo from "./logos/TMNT.png";
import SElogo from "./logos/SE.png";
import TMXlogo from "./logos/TMX.png";
import ODYlogo from "./logos/ODY.png";
import FROGlogo from "./logos/FROG.png";
import GZlogo from "./logos/GZ.png";
import HOOJlogo from "./logos/HOOJ.png";
import JPTlogo from "./logos/JPT.png";
import MRKlogo from "./logos/MRK.png";
import POUTlogo from "./logos/POUT.png";
import UWUlogo from "./logos/UWU.png";

import astralogo from "./agents/astra.png";
import brimlogo from "./agents/brimstone.png";
import cypherlogo from "./agents/cypher.png";
import jettlogo from "./agents/jett.png";
import killjoylogo from "./agents/killjoy.png";
import omenlogo from "./agents/omen.png";
import phoenixlogo from "./agents/phoenix.png";
import razelogo from "./agents/raze.png";
import sagelogo from "./agents/sage.png";
import skyelogo from "./agents/skye.png";
import sovalogo from "./agents/sova.png";
import viperlogo from "./agents/viper.png";
import yorulogo from "./agents/yoru.png";
import reynalogo from "./agents/reyna.png";
import neonlogo from "./agents/neon.png";
import chamberlogo from "./agents/chamber.png";
import harborlogo from "./agents/harbor.png";
import gekkologo from "./agents/gekko.png";
import fadelogo from "./agents/fade.png";
import kayologo from "./agents/kayo.png";
import breachlogo from "./agents/breach.png";

import iron1logo from "./rank/Iron_1_Rank.png";
import iron2logo from "./rank/Iron_2_Rank.png";
import iron3logo from "./rank/Iron_3_Rank.png";
import bronze1logo from "./rank/Bronze_1_Rank.png";
import bronze2logo from "./rank/Bronze_2_Rank.png";
import bronze3logo from "./rank/Bronze_3_Rank.png";
import silver1logo from "./rank/Silver_1_Rank.png";
import silver2logo from "./rank/Silver_2_Rank.png";
import silver3logo from "./rank/Silver_3_Rank.png";
import gold1logo from "./rank/Gold_1_Rank.png";
import gold2logo from "./rank/Gold_2_Rank.png";
import gold3logo from "./rank/Gold_3_Rank.png";
import platinum1logo from "./rank/Platinum_1_Rank.png";
import platinum2logo from "./rank/Platinum_2_Rank.png";
import platinum3logo from "./rank/Platinum_3_Rank.png";
import diamond1logo from "./rank/Diamond_1_Rank.png";
import diamond2logo from "./rank/Diamond_2_Rank.png";
import diamond3logo from "./rank/Diamond_3_Rank.png";
import ascendant1logo from "./rank/Ascendant_1_Rank.png";
import ascendant2logo from "./rank/Ascendant_2_Rank.png";
import ascendant3logo from "./rank/Ascendant_3_Rank.png";
import immortal1logo from "./rank/Immortal_1_Rank.png";
import immortal2logo from "./rank/Immortal_2_Rank.png";
import immortal3logo from "./rank/Immortal_3_Rank.png";
import radiantlogo from "./rank/Radiant_Rank.png";

import './App.css';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import { or, collection, query, where, getDocs, doc, getDoc, setDoc, addDoc, updateDoc, deleteField, QuerySnapshot, orderBy} from "firebase/firestore";
import * as React from 'react';
import {useAuthState} from 'react-firebase-hooks/auth';
import {useCollectionData} from 'react-firebase-hooks/firestore';

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import HenrikDevValorantAPI from 'unofficial-valorant-api';
import { getFirestore } from 'firebase/firestore';
import { useState, useEffect, useRef } from 'react';
import Button from '@mui/material/Button';
import { FormControlLabel, Switch } from "@mui/material";
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { blue } from "@mui/material/colors";
const vapi = new HenrikDevValorantAPI();

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBC3mGvVt65neIWOQT2seJ8SdgeJMi3sJU",
  authDomain: "underpeel.firebaseapp.com",
  projectId: "underpeel",
  storageBucket: "underpeel.appspot.com",
  messagingSenderId: "678606517432",
  appId: "1:678606517432:web:23c2fa7cbe4ea8e15d704d",
  measurementId: "G-PTX05N3NMH"
};
firebase.initializeApp(firebaseConfig);
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const emptyAgents = new Map([
  ["Raze" , 0],
  ["Jett" , 0],
  ["Phoenix" , 0],
  ["Reyna", 0],
  ["Neon", 0],
  ["Yoru", 0],
  ["Sage", 0],
  ["Killjoy", 0],
  ["Cypher", 0],
  ["Chamber", 0],
  ["Brimstone", 0],
  ["Omen", 0],
  ["Viper", 0],
  ["Astra", 0],
  ["Harbor", 0],
  ["Skye", 0],
  ["Sova", 0],
  ["Breach", 0],
  ["Kayo", 0],
  ["Fade", 0],
  ["Gekko", 0]
])

class Player {
  constructor(name, tag, rank, acs, kills, deaths, assists, dd, fd, fk, rp, mp, hs, team, agents_played) {
    this.name = name;
    this.tag = tag;
    this.rank = rank;
    this.acs = acs;
    this.kills = kills;
    this.deaths = deaths;
    this.assists = assists;
    this.dd = dd;
    this.fd = fd;
    this.fk = fk;
    this.rp = rp;
    this.mp = mp; 
    this.hs = hs;
    this.team = team;
    this.agents_played = agents_played;
  }
} 

const playerConverter = {
  toFirestore: (player) => {
    return {
      name: player.name,
      tag: player.tag,
      rank: player.rank,
      acs: player.acs,
      kills: player.kills,
      deaths: player.deaths,
      assists: player.assists,
      dd: player.dd,
      fd: player.fd,
      fk: player.fk,
      rp: player.rp,
      mp: player.mp,
      hs: player.hs,
      team: player.team,
      agents_played: {
        "Raze" : player.agents_played.get("Raze"),
        "Jett" : player.agents_played.get("Jett"),
        "Phoenix" : player.agents_played.get("Phoenix"),
        "Reyna": player.agents_played.get("Reyna"),
        "Neon": player.agents_played.get("Neon"),
        "Yoru": player.agents_played.get("Yoru"),
        "Sage": player.agents_played.get("Sage"),
        "Killjoy": player.agents_played.get("Killjoy"),
        "Cypher": player.agents_played.get("Cypher"),
        "Chamber": player.agents_played.get("Chamber"),
        "Brimstone": player.agents_played.get("Brimstone"),
        "Omen": player.agents_played.get("Omen"),
        "Viper": player.agents_played.get("Viper"),
        "Astra": player.agents_played.get("Astra"),
        "Harbor": player.agents_played.get("Harbor"),
        "Skye": player.agents_played.get("Skye"),
        "Sova": player.agents_played.get("Sova"),
        "Breach": player.agents_played.get("Breach"),
        "Kayo": player.agents_played.get("Kayo"),
        "Fade": player.agents_played.get("Fade"),
        "Gekko" : player.agents_played.get("Gekko"),
      }
    };
  },
  fromFirestore: (snapshot, options) => {
    const data = snapshot.data(options);
    return new Player(data.name, data.tag, data.rank, data.acs, data.kills, data.deaths, data.assists, data.dd, data.fd, data.fk, data.rp, data.mp, data.hs, data.team, data.agents_played);
  }

}

class Match{
  constructor(redTeam, greenTeam, map, redPlayers, greenPlayers, redScore, greenScore, date) {
    this.redTeam = redTeam;
    this.greenTeam = greenTeam;
    this.map = map;
    this.redPlayers = redPlayers;
    this.greenPlayers = greenPlayers;
    this.redScore = redScore;
    this.greenScore = greenScore;
    this.date = date;
  }

  toString() {
    return this.redTeam + " vs " + this.greenTeam + " on " + this.map + " on " + this.date;
  }
}

const matchConverter = {
  toFirestore: (match) => {
    return {
      redTeam: match.redTeam,
      greenTeam: match.greenTeam,
      map: match.map,
      redPlayers: [
        {
          "puuid" : match.redPlayers[0].get("puuid"),
          "name" : match.redPlayers[0].get("name"),
          "tag" : match.redPlayers[0].get("tag"),
          "rank" : match.redPlayers[0].get("rank"),
          "acs" : match.redPlayers[0].get("acs"),
          "kills" : match.redPlayers[0].get("kills"),
          "deaths" : match.redPlayers[0].get("deaths"),
          "assists" : match.redPlayers[0].get("assists"),
          "dd" : match.redPlayers[0].get("dd"),
          "fd" : match.redPlayers[0].get("fd"),
          "fk" : match.redPlayers[0].get("fk"),
          "hs" : match.redPlayers[0].get("hs"),
          "agent" : match.redPlayers[0].get("agent")
        },
        {
          "puuid" : match.redPlayers[1].get("puuid"),
          "name" : match.redPlayers[1].get("name"),
          "tag" : match.redPlayers[1].get("tag"),
          "rank" : match.redPlayers[1].get("rank"),
          "acs" : match.redPlayers[1].get("acs"),
          "kills" : match.redPlayers[1].get("kills"),
          "deaths" : match.redPlayers[1].get("deaths"),
          "assists" : match.redPlayers[1].get("assists"),
          "dd" : match.redPlayers[1].get("dd"),
          "fd" : match.redPlayers[1].get("fd"),
          "fk" : match.redPlayers[1].get("fk"),
          "hs" : match.redPlayers[1].get("hs"),
          "agent" : match.redPlayers[1].get("agent")
        },
        {
          "puuid" : match.redPlayers[2].get("puuid"),
          "name" : match.redPlayers[2].get("name"),
          "tag" : match.redPlayers[2].get("tag"),
          "rank" : match.redPlayers[2].get("rank"),
          "acs" : match.redPlayers[2].get("acs"),
          "kills" : match.redPlayers[2].get("kills"),
          "deaths" : match.redPlayers[2].get("deaths"),
          "assists" : match.redPlayers[2].get("assists"),
          "dd" : match.redPlayers[2].get("dd"),
          "fd" : match.redPlayers[2].get("fd"),
          "fk" : match.redPlayers[2].get("fk"),
          "hs" : match.redPlayers[2].get("hs"),
          "agent" : match.redPlayers[2].get("agent")
        },
        {
          "puuid" : match.redPlayers[3].get("puuid"),
          "name" : match.redPlayers[3].get("name"),
          "tag" : match.redPlayers[3].get("tag"),
          "rank" : match.redPlayers[3].get("rank"),
          "acs" : match.redPlayers[3].get("acs"),
          "kills" : match.redPlayers[3].get("kills"),
          "deaths" : match.redPlayers[3].get("deaths"),
          "assists" : match.redPlayers[3].get("assists"),
          "dd" : match.redPlayers[3].get("dd"),
          "fd" : match.redPlayers[3].get("fd"),
          "fk" : match.redPlayers[3].get("fk"),
          "hs" : match.redPlayers[3].get("hs"),
          "agent" : match.redPlayers[3].get("agent")
        },
        {
          "puuid" : match.redPlayers[4].get("puuid"),
          "name" : match.redPlayers[4].get("name"),
          "tag" : match.redPlayers[4].get("tag"),
          "rank" : match.redPlayers[4].get("rank"),
          "acs" : match.redPlayers[4].get("acs"),
          "kills" : match.redPlayers[4].get("kills"),
          "deaths" : match.redPlayers[4].get("deaths"),
          "assists" : match.redPlayers[4].get("assists"),
          "dd" : match.redPlayers[4].get("dd"),
          "fd" : match.redPlayers[4].get("fd"),
          "fk" : match.redPlayers[4].get("fk"),
          "hs" : match.redPlayers[4].get("hs"),
          "agent" : match.redPlayers[4].get("agent")
        }
      ],
      greenPlayers: [
        {
          "puuid" : match.greenPlayers[0].get("puuid"),
          "name" : match.greenPlayers[0].get("name"),
          "tag" : match.greenPlayers[0].get("tag"),
          "rank" : match.greenPlayers[0].get("rank"),
          "acs" : match.greenPlayers[0].get("acs"),
          "kills" : match.greenPlayers[0].get("kills"),
          "deaths" : match.greenPlayers[0].get("deaths"),
          "assists" : match.greenPlayers[0].get("assists"),
          "dd" : match.greenPlayers[0].get("dd"),
          "fd" : match.greenPlayers[0].get("fd"),
          "fk" : match.greenPlayers[0].get("fk"),
          "hs" : match.greenPlayers[0].get("hs"),
          "agent" : match.greenPlayers[0].get("agent")
        },
        {
          "puuid" : match.greenPlayers[1].get("puuid"),
          "name" : match.greenPlayers[1].get("name"),
          "tag" : match.greenPlayers[1].get("tag"),
          "rank" : match.greenPlayers[1].get("rank"),
          "acs" : match.greenPlayers[1].get("acs"),
          "kills" : match.greenPlayers[1].get("kills"),
          "deaths" : match.greenPlayers[1].get("deaths"),
          "assists" : match.greenPlayers[1].get("assists"),
          "dd" : match.greenPlayers[1].get("dd"),
          "fd" : match.greenPlayers[1].get("fd"),
          "fk" : match.greenPlayers[1].get("fk"),
          "hs" : match.greenPlayers[1].get("hs"),
          "agent" : match.greenPlayers[1].get("agent")
        },
        {
          "puuid" : match.greenPlayers[2].get("puuid"),
          "name" : match.greenPlayers[2].get("name"),
          "tag" : match.greenPlayers[2].get("tag"),
          "rank" : match.greenPlayers[2].get("rank"),
          "acs" : match.greenPlayers[2].get("acs"),
          "kills" : match.greenPlayers[2].get("kills"),
          "deaths" : match.greenPlayers[2].get("deaths"),
          "assists" : match.greenPlayers[2].get("assists"),
          "dd" : match.greenPlayers[2].get("dd"),
          "fd" : match.greenPlayers[2].get("fd"),
          "fk" : match.greenPlayers[2].get("fk"),
          "hs" : match.greenPlayers[2].get("hs"),
          "agent" : match.greenPlayers[2].get("agent")
        },
        {
          "puuid" : match.greenPlayers[3].get("puuid"),
          "name" : match.greenPlayers[3].get("name"),
          "tag" : match.greenPlayers[3].get("tag"),
          "rank" : match.greenPlayers[3].get("rank"),
          "acs" : match.greenPlayers[3].get("acs"),
          "kills" : match.greenPlayers[3].get("kills"),
          "deaths" : match.greenPlayers[3].get("deaths"),
          "assists" : match.greenPlayers[3].get("assists"),
          "dd" : match.greenPlayers[3].get("dd"),
          "fd" : match.greenPlayers[3].get("fd"),
          "fk" : match.greenPlayers[3].get("fk"),
          "hs" : match.greenPlayers[3].get("hs"),
          "agent" : match.greenPlayers[3].get("agent")
        },
        {
          "puuid" : match.greenPlayers[4].get("puuid"),
          "name" : match.greenPlayers[4].get("name"),
          "tag" : match.greenPlayers[4].get("tag"),
          "rank" : match.greenPlayers[4].get("rank"),
          "acs" : match.greenPlayers[4].get("acs"),
          "kills" : match.greenPlayers[4].get("kills"),
          "deaths" : match.greenPlayers[4].get("deaths"),
          "assists" : match.greenPlayers[4].get("assists"),
          "dd" : match.greenPlayers[4].get("dd"),
          "fd" : match.greenPlayers[4].get("fd"),
          "fk" : match.greenPlayers[4].get("fk"),
          "hs" : match.greenPlayers[4].get("hs"),
          "agent" : match.greenPlayers[4].get("agent")
        }
      ],
      redScore: match.redScore,
      greenScore: match.greenScore,
      date: match.date
    };
  },
  fromFirestore: (snapshot, options) => {
    const data = snapshot.data(options);
    return new Match(data.redTeam, data.greenTeam, data.map, data.redPlayers, data.greenPlayers, data.redScore, data.greenScore, data.date);
  }
}


let count = 0;

function PlayersPage() {
  const [playerData, setPlayerData] = useState('');

  useEffect(() => {
    const getData = async () => {
      const playerRef = doc(db, "players", "79adb41d-3cea-5a48-8ce9-4681619ec4bc").withConverter(playerConverter);
      const docSnap = await getDoc(playerRef);
      if (docSnap.exists()) {
        console.log("Document data:", docSnap.data());
        setPlayerData(docSnap.data());
      } else {
        console.log("no such document");
      }
    }
    getData();
  }, []);

  console.log(playerData);
  return (
    <>
      <div>
        {playerData.team}
      </div>
    </>
  );
}

async function getRank(id) {
  const profile = await vapi.getMMRByPUUID({version: 'v2', region: 'na', puuid: id});
  console.log(id, profile.data);
  return profile.data.current_data.currenttierpatched;
}

async function addMatch(matchID, team1, team2) {
  matchID = matchID.split("match/")[1];
  console.log(matchID, team1, team2);
  const vmatch =  await vapi.getMatch({match_id: matchID});
  console.log(vmatch);
  const fk = new Map();
  const fd = new Map();
  let curr_round = -1;
  for (let i = 0; i < vmatch.data.kills.length; i++) {
    const k = vmatch.data.kills[i];
    if (k.round != curr_round) {
      curr_round = k.round;
      fk.set(k.killer_puuid, fk.get(k.killer_puuid) + 1 || 1);
      fd.set(k.victim_puuid, fd.get(k.victim_puuid) + 1 || 1);
    }
  }
  console.log(fk);
  console.log(fd);

  const redTeam = vmatch.data.players.red;
  const greenTeam = vmatch.data.players.blue;
  console.log(redTeam);
  console.log(greenTeam);
  console.log(vmatch.data.metadata.rounds_played)
  let redPlayers = new Array(5);
  let greenPlayers = new Array(5);
  for (let i = 0; i < redTeam.length; i++) {
    const playerRef = redTeam[i];
    redPlayers[i] = new Map([
      ["puuid", playerRef.puuid],
      ["name", playerRef.name],
      ["tag", playerRef.tag],
      ["rank", await getRank(playerRef.puuid)],
      ["acs", playerRef.stats.score / vmatch.data.metadata.rounds_played],
      ["kills", playerRef.stats.kills],
      ["deaths", playerRef.stats.deaths],
      ["assists", playerRef.stats.assists],
      ["dd", (playerRef.damage_made - playerRef.damage_received) / vmatch.data.metadata.rounds_played],
      ["fd", fd.get(playerRef.puuid) || 0] ,
      ["fk", fk.get(playerRef.puuid) || 0],
      ["hs", (playerRef.stats.headshots / (playerRef.stats.headshots + playerRef.stats.bodyshots + playerRef.stats.legshots))],
      ["agent", playerRef.character]
    ]);
    const playerRef2 = greenTeam[i];
    greenPlayers[i] = new Map([
      ["puuid", playerRef2.puuid],
      ["name", playerRef2.name],
      ["tag", playerRef2.tag],
      ["rank", await getRank(playerRef2.puuid)],
      ["acs", playerRef2.stats.score / vmatch.data.metadata.rounds_played],
      ["kills", playerRef2.stats.kills],
      ["deaths", playerRef2.stats.deaths],
      ["assists", playerRef2.stats.assists],
      ["dd", (playerRef2.damage_made - playerRef2.damage_received) / vmatch.data.metadata.rounds_played],
      ["fd", fd.get(playerRef2.puuid) || 0] ,
      ["fk", fk.get(playerRef2.puuid) || 0],
      ["hs", (playerRef2.stats.headshots / (playerRef2.stats.headshots + playerRef2.stats.bodyshots + playerRef2.stats.legshots))],
      ["agent", playerRef2.character]
    ]);
    if (redPlayers[i].get("agent") == "KAY/O") {
      redPlayers[i].set("agent", "Kayo");
    }
    if (greenPlayers[i].get("agent") == "KAY/O") {
      greenPlayers[i].set("agent", "Kayo");
    }
  }

  for (let i = 0; i < redPlayers.length; i++) {
    const playerRef = doc(db, "players", redPlayers[i].get("puuid")).withConverter(playerConverter);
    const docSnap = await getDoc(playerRef);
    if (docSnap.exists()) {
      const player = docSnap.data();
      await updateDoc(playerRef, {
        "rank" : redPlayers[i].get("rank"),
        "acs" : player.acs + redPlayers[i].get("acs"),
        "kills" : player.kills + redPlayers[i].get("kills"),
        "deaths" : player.deaths + redPlayers[i].get("deaths"),
        "assists" : player.assists + redPlayers[i].get("assists"),
        "dd" : player.dd + redPlayers[i].get("dd"),
        "fd" : player.fd + redPlayers[i].get("fd"),
        "fk" : player.fk + redPlayers[i].get("fk"),
        "hs" : player.hs + redPlayers[i].get("hs"),
        "mp" : player.mp + 1,
        "rp" : player.rp + vmatch.data.metadata.rounds_played,
        [`agents_played.${redPlayers[i].get("agent")}`] : player.agents_played[redPlayers[i].get("agent")] + 1
      });
      console.log("updated player", redPlayers[i].get("name"));
    } else {
      const agentMap = new Map(emptyAgents);
      agentMap.set(redPlayers[i].get("agent"), 1);
      const subPlayer = new Player(redPlayers[i].get("name"), redPlayers[i].get("tag"), redPlayers[i].get("rank"), redPlayers[i].get("acs"), redPlayers[i].get("kills"), redPlayers[i].get("deaths"), redPlayers[i].get("assists"), redPlayers[i].get("dd"), redPlayers[i].get("fd"), redPlayers[i].get("fk"), vmatch.data.metadata.rounds_played, 1, redPlayers[i].get("hs"), "SUB",
       agentMap);
      console.log(subPlayer);      
      await setDoc(playerRef, subPlayer);
      console.log("created player", redPlayers[i].get("name"));
    }
  }

  for (let i = 0; i < greenPlayers.length; i++) {
    const playerRef = doc(db, "players", greenPlayers[i].get("puuid")).withConverter(playerConverter);
    const docSnap = await getDoc(playerRef);
    if (docSnap.exists()) {
      const player = docSnap.data();
      await updateDoc(playerRef, {
        "rank" : greenPlayers[i].get("rank"),
        "acs" : player.acs + greenPlayers[i].get("acs"),
        "kills" : player.kills + greenPlayers[i].get("kills"),
        "deaths" : player.deaths + greenPlayers[i].get("deaths"),
        "assists" : player.assists + greenPlayers[i].get("assists"),
        "dd" : player.dd + greenPlayers[i].get("dd"),
        "fd" : player.fd + greenPlayers[i].get("fd"),
        "fk" : player.fk + greenPlayers[i].get("fk"),
        "hs" : player.hs + greenPlayers[i].get("hs"),
        "mp" : player.mp + 1,
        "rp" : player.rp + vmatch.data.metadata.rounds_played,
        [`agents_played.${greenPlayers[i].get("agent")}`] : player.agents_played[greenPlayers[i].get("agent")] + 1
      });
      console.log("updated player", greenPlayers[i].get("name"));
    } else {
      const agentMap = new Map(emptyAgents);
      agentMap.set(greenPlayers[i].get("agent"), 1);
      const subPlayer = new Player(greenPlayers[i].get("name"), greenPlayers[i].get("tag"), greenPlayers[i].get("rank"), greenPlayers[i].get("acs"), greenPlayers[i].get("kills"), greenPlayers[i].get("deaths"), greenPlayers[i].get("assists"), greenPlayers[i].get("dd"), greenPlayers[i].get("fd"), greenPlayers[i].get("fk"), vmatch.data.metadata.rounds_played, 1, greenPlayers[i].get("hs"), "SUB",
       agentMap);
      console.log(subPlayer);
      await setDoc(playerRef, subPlayer);
      console.log("added player", greenPlayers[i].get("name"));
    }
    
  }


  const match = new Match(team1, team2, vmatch.data.metadata.map, redPlayers, greenPlayers, vmatch.data.teams.red.rounds_won, vmatch.data.teams.blue.rounds_won, vmatch.data.metadata.game_start);
  console.log(match);
  console.log(match.redPlayers[0].get("puuid"));
  const newMatchRef = doc(collection(db, "matches")).withConverter(matchConverter);
  await setDoc(newMatchRef, match);
}


const standings = [
  { Team : "GQ", W: 6, L : 0, RD: 35, Logo: GQlogo},
  { Team : "LOUD", W: 4, L : 2, RD: 14, Logo: LOUDlogo},
  { Team : "FNC", W: 4, L : 2, RD: -7, Logo: FNClogo},
  { Team : "ATZ", W: 3, L : 2, RD: 9, Logo: ATZlogo},
  { Team : "SE", W: 2, L : 2, RD: 11, Logo: SElogo},
  { Team : "TMX", W: 2, L : 2, RD: -2, Logo: TMXlogo},
  { Team : "SCN", W: 2, L : 3, RD: -6, Logo: SCNlogo},
  { Team : "TMNT", W: 1, L : 3, RD: -3, Logo: TMNTlogo},
  { Team : "ODY", W: 0, L : 5, RD: -24, Logo: ODYlogo}
];

const viberStandings = [
  { Team : "GZ", W: 2, L : 0, RD: 12, Logo: GZlogo},
  { Team : "UWU", W: 2, L : 0, RD: 8, Logo: UWUlogo},
  { Team : "JPT", W: 2, L : 1, RD: -2, Logo: JPTlogo},
  { Team : "POUT", W: 1, L : 1, RD: 2, Logo: POUTlogo},
  { Team : "MRK", W: 1, L : 2, RD: 6, Logo: MRKlogo},
  { Team : "FROG", W: 1, L : 2, RD: -9, Logo: FROGlogo},
  { Team : "HOOJ", W: 0, L : 3, RD: -16, Logo: HOOJlogo}
];

const tagToTeam = new Map([
  ["SE" , "Six Eyes"],
  ["GQ" , "Good Question"],
  ["LOUD" , "Living Out Ur Dreams"],
  ["FNC" , "Fun Near Carrots"],
  ["ATZ" , "All Time Zones"],
  ["TMX" , "Team X"],
  ["SCN" , "Shrouded Cyclone"],
  ["TMNT" , "Those Meddling Neanderthals There"],
  ["ODY" , "Odyssey"],
  ["SUB", "SUB"]
]);

const teamToLogo = new Map([
  ["Six Eyes" , SElogo],
  ["Good Question" , GQlogo],
  ["Living Out Ur Dreams" , LOUDlogo],
  ["Fun Near Carrots" , FNClogo],
  ["All Time Zones" , ATZlogo],
  ["Team X" , TMXlogo],
  ["Shrouded Cyclone" , SCNlogo],
  ["Those Meddling Neanderthals There" , TMNTlogo],
  ["Odyssey" , ODYlogo]
]);

const teamToTag = new Map([
  ["Six Eyes", "SE"],
  ["Good Question", "GQ"],
  ["Living Out Ur Dreams", "LOUD"],
  ["Fun Near Carrots", "FNC"],
  ["All Time Zones", "ATZ"],
  ["Team X", "TMX"],
  ["Shrouded Cyclone", "SCN"],
  ["Those Meddling Neanderthals There", "TMNT"],
  ["Odyssey", "ODY"],
  ["SUB", "SUB"]
]);

const agentToLogo = new Map([
  ["Astra", astralogo],
  ["Breach", breachlogo],
  ["Brimstone", brimlogo],
  ["Cypher", cypherlogo],
  ["Chamber", chamberlogo],
  ["Fade", fadelogo],
  ["Gekko", gekkologo],
  ["Harbor", harborlogo],
  ["Jett", jettlogo],
  ["Kayo", kayologo],
  ["Killjoy", killjoylogo],
  ["Neon", neonlogo],
  ["Omen", omenlogo],
  ["Phoenix", phoenixlogo],
  ["Raze", razelogo],
  ["Reyna", reynalogo],
  ["Sage", sagelogo],
  ["Skye", skyelogo],
  ["Sova", sovalogo],
  ["Viper", viperlogo],
  ["Yoru", yorulogo],
  ["KAY/O", kayologo]
])

const rankToLogo = new Map([
  ["Iron 1", iron1logo],
  ["Iron 2", iron2logo],
  ["Iron 3", iron3logo],
  ["Bronze 1", bronze1logo],
  ["Bronze 2", bronze2logo],
  ["Bronze 3", bronze3logo],
  ["Silver 1", silver1logo],
  ["Silver 2", silver2logo],
  ["Silver 3", silver3logo],
  ["Gold 1", gold1logo],
  ["Gold 2", gold2logo],
  ["Gold 3", gold3logo],
  ["Platinum 1", platinum1logo],
  ["Platinum 2", platinum2logo],
  ["Platinum 3", platinum3logo],
  ["Ascendant 1", ascendant1logo],
  ["Ascendant 2", ascendant2logo],
  ["Ascendant 3", ascendant3logo],
  ["Diamond 1", diamond1logo],
  ["Diamond 2", diamond2logo],
  ["Diamond 3", diamond3logo],
  ["Immortal 1", immortal1logo],
  ["Immortal 2", immortal2logo],
  ["Immortal 3", immortal3logo],
  ["Radiant", radiantlogo]
])

function App() {
  const [home, setHome] = useState(true);
  const [team, setTeam] = useState('Six Eyes');
  console.log(team);
  return (
    <div className="App">
      {home? <HomeMain setTeam = {setTeam} setHome = {setHome} team = {team} /> : <DisplayTeam team={team} setHome = {setHome} setTeam = {setTeam}/>}
    </div>
  );
}


function HomeMain(props) {
  const [mod, setMod] = useState(false);
  

  return (
    <>
      {mod? <ModMenu setMod = {setMod}/> : <Home setMod={setMod} team = {props.team} setTeam = {props.setTeam} setHome = {props.setHome}/>}
    </>
  );
}


function ModMenu(props) {
  const [team1, setTeam1] = useState('');
  const [team2, setTeam2] = useState('');
  const [tracker, setTracker] = useState('');
  return (
    <>
      <header className="App-header">
      <Button variant = "contained" onClick={() => props.setMod(false)}> Back </Button>
      </header>
      <main className="App-main">
        <div className = "form container">
          <select class="form-select" aria-label="Default select example"  onChange={e => setTeam1(e.target.value)}>
            <option selected>Green Team</option>
            <option value="All Time Zones">ATZ</option>
            <option value="Fun Near Carrots">FNC</option>
            <option value="Good Question">GQ</option>
            <option value="Living Out Ur Dreams">LOUD</option>
            <option value="Odyssey">ODY</option>
            <option value="Shrouded Cyclone">SCN</option>
            <option value="Six Eyes">SE</option>
            <option value="Those Meddling Neanderthals There">TMNT</option>
            <option value="Team X">TMX</option>
          </select>
          <select class="form-select" aria-label="Default select example" onChange={e => setTeam2(e.target.value)}>
            <option selected>Red Team</option>
            <option value="All Time Zones">ATZ</option>
            <option value="Fun Near Carrots">FNC</option>
            <option value="Good Question">GQ</option>
            <option value="Living Out Ur Dreams">LOUD</option>
            <option value="Odyssey">ODY</option>
            <option value="Shrouded Cyclone">SCN</option>
            <option value="Six Eyes">SE</option>
            <option value="Those Meddling Neanderthals There">TMNT</option>
            <option value="Team X">TMX</option>
          </select>
          <input class="form-control" type="text" placeholder="Tracker Link" aria-label="default input example"   onChange={e => setTracker(e.target.value)}></input>
        </div>
        <Button variant = "contained" onClick={() => addMatch(tracker, team1, team2)}> Submit </Button>
      </main>
    </>
  )
}

function Home(props) {
  const [sweater, setSweater] = useState(true);
  const [league, setLeague] = useState('Sweater');

  const handleSwitch = () => {
    setSweater(!sweater);
    if (sweater) {
      setLeague('Viber');
    } else {
      setLeague('Sweater');
    }
    console.log(league);
    console.log(sweater);
  }
  return (
  <>
      <header className="App-header">
          <ListGames />
          <Button variant = "contained" onClick={() => console.log("disabled")}> MODS </Button>
      </header>
      <main className="App-main">
        <FormControlLabel control={<Switch defaultChecked />} label={league} onChange={() => handleSwitch()} />
        {sweater? <TeamStandings team = {props.team} setTeam = {props.setTeam} setHome = {props.setHome}/>: <ViberTeamStandings/>}
        <PlayerStats/>
      </main>
  </>
  )
}

function ViberTeamStandings() {
  const rows = viberStandings.map((standing) => (
    <tr className ="tab-row" key = {standing.Team}>
      <td className="tab-logo"><img className ="teamLogo" src = {standing.Logo} alt = {standings.Team + "logo"}  /> {standing.Team}</td>
      <td className="tab-cell">{standing.W}</td>
      <td className="tab-cell">{standing.L}</td>
      <td className="tab-cell" style={{color: getRDColor(standing.RD)}}>{standing.RD}</td>
    </tr> 
  ));
  return (
    <table className="tab">
      <thead>
        <tr className="tab-row">
          <th className="tab-cell">Team</th>
          <th className="tab-cell">W</th>
          <th className="tab-cell">L</th>
          <th className="tab-cell">RD</th>
        </tr>
      </thead>
      <tbody className="tab-body">
        {rows}
      </tbody>
    </table>
  )
};

function DisplayTeam(props) {
  const [back, setBack] = useState(true);
  const [matchID, setMatchID] = useState('');
  return (
    <>
      {back? <Team team = {props.team} setHome = {props.setHome} setTeam = {props.setTeam} setMatchID= {setMatchID} setBack = {setBack}/> : <MatchPage matchID = {matchID} setBack = {setBack}/>}
    </>
  )
}

function Team(props){
  console.log(props.team);
  const handleClick = () => {
    props.setHome(true);
  }


  const teamlogo = teamToLogo.get(props.team);

  return (
    <>
      <header className="Team-header">
        <Button className = "home-button" variant = "contained" onClick={() => handleClick()}>
          Home
        </Button>
        <p className="team-header-text">{props.team}</p>
        <img className='team-img' src = {teamlogo} alt = {"logo"} />
      </header>
      <main className="Team-main">
        <div className="stats-container">
          <p> Team Stats</p>
          <TeamStats team = {props.team}/>
        </div>  
        <div className = "matches-container">
          <MatchList team = {props.team} setBack = {props.setBack} setMatchID = {props.setMatchID} />
        </div>    
      </main>
    </>
  )
}

function MatchList({team, setBack, setMatchID}) {
  const [matchlist, setMatchList] = useState([]);
  useEffect(() => {
    async function fetchMatches() {
      const q = query(collection(db, "matches"), or(where("greenTeam", "==", team), where("redTeam", "==", team)));
      const p = await getDocs(q);
      const tempList = [];
      p.forEach((match) => {
        tempList.push(match.data());
      }
      );
      setMatchList(tempList);
    }
    fetchMatches();

  }, [team]);
  console.log(matchlist);

  return (
    <>
      {matchlist.map((match) => (
        <MatchBox setBack = {setBack} setMatchID = {setMatchID} match={match} team1 = {match.redTeam} team2 = {match.greenTeam} team1score = {match.redScore} team2score = {match.greenScore} map = {match.map} />
      ))}
    </>
  )
}

function MatchBox(props) {
  const handleClick = () => {
    props.setBack(false);
    props.setMatchID(props.match);
  }
  return (
    <div className = "match-box" onClick={handleClick}>
      <p>{teamToTag.get(props.team1)} {props.team1score} - {teamToTag.get(props.team2)} {props.team2score}</p>
      <p> {props.map} </p>
    </div>
    )
  
}

function TeamStats({team}) {
  const [PlayerList, setPlayerList] = useState([]);
  console.log("Six Eyes" == team);
  useEffect(() => {
    async function fetchPlayers() {
      const q = query(collection(db, "players"), where("team", "==", team));
      console.log("teamsfsd", team);
      const p = await getDocs(q);
      const tempList = [];
      p.forEach((player) => {
        tempList.push(player.data());
      }
      );
      setPlayerList(tempList);
    }
    fetchPlayers();
  }, [team]);
  console.log(PlayerList);


  return (
    <>
      <PlayerLabel/>
      <div className="team-table-container">
        {PlayerList.map((player) => (
          <PlayerDisplay player={player} />
        ))}
      </div>
    </>
  );
}


function PlayerStats() {
  const [playerList, setPlayerList] = useState([]);
  const [filter, setFilter] = useState("");
  
  function compare(a, b) {
    if ((a.acs/a.mp) < (b.acs/b.mp)) {
      return 1;
    } else {
      return -1;
    }
  }
  useEffect(() => {
    async function fetchPlayers() {
      let q;
      if (filter == "") {
        q = query(collection(db, "players"), where("mp", ">=", 1), orderBy("mp", "desc"));
      } else {
        q = query(collection(db, "players"), where("team", "==", filter));
        console.log(filter, q);
      }
      
      const p = await getDocs(q);
      const tempList = [];
      p.forEach((player) => {
        tempList.push(player.data());
      }
      );
      tempList.sort(compare);
      setPlayerList(tempList);
    }
    fetchPlayers();
  }, [filter]);
  console.log(playerList.length);



  return (
    <>
    <select class="form-select" aria-label="Default select example"  onChange={e => setFilter(e.target.value)}>
        <option selected value="">All teams</option>
        <option value="All Time Zones">ATZ</option>
        <option value="Fun Near Carrots">FNC</option>
        <option value="Good Question">GQ</option>
        <option value="Living Out Ur Dreams">LOUD</option>
        <option value="Odyssey">ODY</option>
        <option value="Shrouded Cyclone">SCN</option>
        <option value="Six Eyes">SE</option>
        <option value="Those Meddling Neanderthals There">TMNT</option>
        <option value="Team X">TMX</option>
        <option value="SUB">Subs</option>
      </select>
      <PlayerLabel/>
      <div className="player-table-container">
        {playerList.map((player) => (
          <PlayerDisplay player={player} />
        ))}
      </div>
    </>
  )
}

function getRDColor(val) {
  if (val  > 0) {
    return "#00ff00";
  } else {
    return "#ff0000";
  }
}

function TeamStandings(props) {
  const handleTeamClick = (teamtag) => {
    props.setTeam(tagToTeam.get(teamtag));
    props.setHome(false);
  }

  const rows = standings.map((standing) => (
    <tr className ="tab-row" key = {standing.Team}>
      <td className="tab-logo" onClick={() => handleTeamClick(standing.Team)} style={{color: "blue"}}><img className ="teamLogo" src = {standing.Logo} alt = {standings.Team + "logo"}  /> {standing.Team}</td>
      <td className="tab-cell">{standing.W}</td>
      <td className="tab-cell">{standing.L}</td>
      <td className="tab-cell" style={{color: getRDColor(standing.RD)}}>{standing.RD}</td>
    </tr> 
  ));
  return (
    <table className="tab">
      <thead>
        <tr className="tab-row">
          <th className="tab-cell">Team</th>
          <th className="tab-cell">W</th>
          <th className="tab-cell">L</th>
          <th className="tab-cell">RD</th>
        </tr>
      </thead>
      <tbody className="tab-body">
        {rows}
      </tbody>
    </table>
  )
};

function round2Decimal(num) {
  return Math.round(num * 100) / 100;
}

function PlayerLabel() {
  return (
    <div className="player-label">
      <div className="player-team-name">
        <p className="plabel">Player</p>
      </div>
      <div className="rank-display">
        <p className="plabel">Rank</p>
      </div>
      <div className="mp-display">
        <p className="plabel">MP</p>
      </div>
      <div className="agent-display">
        <p className="plabel">Top 3 Agents</p>
      </div>
      <div className="acs-display">
        <p className="plabel"> ACS </p>
      </div>
      <div className="kda-display">
        <p className="plabel">
          K / D / A
        </p>
      </div>
      <div className="pm-display">
        <p className="plabel" > +/- </p>
      </div>
      <div className="hs-display">
        <p className="plabel">HS%</p>
      </div>
      <div className="fkfd-display">
        <p className="plabel">FK</p>
      </div>
      <div className="fkfd-display">
        <p className="plabel">FD</p>
      </div>
    </div>
  )
}
function PlayerDisplay({player}) {
  function getTopThreeFields(obj) {
    // Convert object to array of [key, value] pairs
    var entries = Object.entries(obj);
  
    // Sort array by the value in descending order
    var sorted = entries.sort((a, b) => b[1] - a[1]);
  
    // Filter out entries with zero values
    var filtered = sorted.filter((item) => item[1] > 0);

    // Return the top 3 (or less) keys
    return filtered.slice(0, 3).map(item => item[0]);
  }
  const topThreeAgents = getTopThreeFields(player.agents_played);
  console.log(count);
  return (
    <div className="player-display">
      <div className="player-team-name">
        <p className="ptext">{teamToTag.get(player.team)} {player.name}</p>
      </div>
      <div className="rank-display">
        <img className="rank-icon" src={rankToLogo.get(player.rank)} alt={player.rank} />
      </div>
      <div className="mp-display">
        <p className="ptext">{player.mp}</p>
      </div>
      <div className="agent-display">
        {topThreeAgents.map((agent) => (
          <img className="agent-icon" src={agentToLogo.get(agent)} alt={agent} />
        ))}
      </div>
      <div className="acs-display">
        <p className="ptext">{round2Decimal(player.acs / player.mp)}</p>
      </div>
      <div className="kda-display">
        <p className="ptext">
          {round2Decimal(player.kills / player.mp)} / {round2Decimal(player.deaths / player.mp)} / {round2Decimal(player.assists / player.mp)}
        </p>
      </div>
      <div className="pm-display">
        <p className="ptext" style={{color: getRDColor(round2Decimal((player.kills - player.deaths) / player.mp))}}>{round2Decimal((player.kills - player.deaths) / player.mp)}</p>
      </div>
      <div className="hs-display">
        <p className="ptext">{round2Decimal(player.hs / player.mp * 100)}%</p>
      </div>
      <div className="fkfd-display">
        <p className="ptext">{round2Decimal(player.fk / player.mp)}</p>
      </div>
      <div className="fkfd-display">
        <p className="ptext">{round2Decimal(player.fd / player.mp)}</p>
      </div>
    </div>
  )
}

function MatchPlayerDisplay({player, team}) {
  return (
    <div className="player-display">
      <div className="team-logo-display">
        <img className="match-team-icon" src={teamToLogo.get(team)} alt={team} />
      </div>
      <div className="player-name-display">
        <p className="ptext">{player.name}</p>
      </div>
      <div className="rank-display">
        <img className="rank-icon" src={rankToLogo.get(player.rank)} alt={player.rank} />
      </div>
      <div className="match-agent-display">
        <img className="agent-icon" src={agentToLogo.get(player.agent)} alt={player.agent} />
      </div>
      
      <div className="stats-label-container">
        <p className="match-stats-label">ACS:</p>
        <div className="acs-display">
          <p className="ptext">{round2Decimal(player.acs)}</p>
        </div>
      </div>
      <div className="stats-label-container">
        <p className="match-stats-label">K/D/A:</p>
        <div className="kda-display">
          <p className="ptext">
            {player.kills} / {player.deaths} / {player.assists}
          </p>
        </div>
      </div>
      <div className="stats-label-container">
        <p className="match-stats-label">P/M:</p>
        <div className="pm-display">
          <p className="ptext" style={{color: getRDColor(player.kills - player.deaths)}}>{player.kills - player.deaths }</p>
        </div>
      </div>
      <div className="stats-label-container">
        <p className="match-stats-label">HS%:</p>
        <div className="hs-display">
          <p className="ptext">{round2Decimal(player.hs  * 100)}%</p>
        </div>
      </div>
      <div className="stats-label-container">
        <p className="match-stats-label">FK:</p>
        <div className="fkfd-display">
          <p className="ptext">{player.fk}</p>
        </div>
      </div>
      <div className="stats-label-container">
        <p className="match-stats-label">FD:</p>
        <div className="fkfd-display">
          <p className="ptext">{player.fd}</p>
        </div>
      </div>
    </div>
  )

}

function MatchPage({matchID, setBack}) {
  const handleClick = () => {
    setBack(true);
  }
  console.log(matchID.greenPlayers[0] );
  return (
    <>
      <header className = "Match-header">
        <Button className = "home-button" variant = "contained" onClick={() => handleClick()}>
          Back
        </Button>
        <div className = "score-container">
          <p> {teamToTag.get(matchID.greenTeam)} </p>
          <img className="team-logo-header" src={teamToLogo.get(matchID.greenTeam)} alt={matchID.greenTeam} />
          <p> {matchID.greenScore} </p>
          <p> - </p>
          <p> {matchID.redScore} </p>
          <img className="team-logo-header" src={teamToLogo.get(matchID.redTeam)} alt={matchID.redTeam} />
          <p> {teamToTag.get(matchID.redTeam)} </p>
        </div>
      </header>
      <main className = "Match-main">
        <div className = "match-stats-container">
          <p className="map-header-text">{matchID.map}</p>
          <div className = "green-team-stats">
            <img className="team-logo-header" src={teamToLogo.get(matchID.greenTeam)} alt={matchID.greenTeam}/>
            {matchID.greenPlayers.map((player) => (
              <MatchPlayerDisplay player={player} team={matchID.greenTeam} />
            ))}
          </div>
          <div className = "red-team-stats">
          <img className="team-logo-header" src={teamToLogo.get(matchID.redTeam)} alt={matchID.redTeam}/>
            {matchID.redPlayers.map((player) => (
              <MatchPlayerDisplay player={player} team={matchID.redTeam} />
            ))}
          </div>
        </div>
      </main>
    </>
  );
}
function ListGames() {
  const [matchlist, setList] = useState([]);
  useEffect(() => {
    async function getUpcoming() {
      const matches = await getDocs(collection(db, "upcoming"));
      console.log(matches);
      const tempList = [];
      matches.forEach((match) => {
        const data = match.data();
        console.log(data);
        tempList.push(data);
      });
      setList(tempList);
    }
    getUpcoming();
  }, []);
  
  console.log(matchlist);
  return (
    <>
      {matchlist.map((match) => (
        <UpcomingGame team1={match.team1} team2={match.team2} time={match.time} />
      ))
      }
    </>
  
  )
}

function UpcomingGame(props) {
  return (
    <div className="upcoming">
      <p>
        {props.team1} vs {props.team2}
      </p>
      <p>
        {props.time}
      </p>
    </div>
  )
}



export default App;
